import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { decodeJWT } from '../../../services/candidateService';
import { ClientService } from '../../../services/clientService';
import { ShortlistHistoryItem } from './shortlistHistoryItem';

export const ShortlistDetailsSection = ({
    shortlistDetails = [],
    candidateId,
    refreshShortlistDetails,
}) => {
    const decoded = decodeJWT(localStorage.getItem('authToken'));
    const username = decoded?.username;

    const [activeTab, setActiveTab] = useState(
        shortlistDetails[0]?.folder?.folderId || null
    );

    const [editModal, setEditModal] = useState({
        open: false,
        folderId: null,
        historyNodeId: null,
        noteId: null,
        note: '',
    });

    const [addNoteModal, setAddNoteModal] = useState({
        open: false,
        note: '',
    });

    const [deleteModal, setDeleteModal] = useState({
        open: false,
        folderId: null,
        historyNodeId: null,
        noteId: null,
    });

    const handleAddNote = async (folderId, historyNodeId, note) => {
        if (!note.trim()) return;

        await ClientService.addNote({
            candidateId,
            folderId,
            noteRequest: { historyNodeId, note },
        });

        refreshShortlistDetails();
    };

    const handleEditNote = (folderId, historyNodeId, noteId, oldNote) => {
        setEditModal({
            open: true,
            folderId,
            historyNodeId,
            noteId,
            note: oldNote,
        });
    };
    const handleDeleteNote = (folderId, historyNodeId, noteId) => {
        setDeleteModal({
            open: true,
            folderId,
            historyNodeId,
            noteId,
        });
    };

    const confirmDeleteNote = async () => {
        const { folderId, historyNodeId, noteId } = deleteModal;

        await ClientService.deleteNote({
            candidateId,
            folderId,
            noteRequest: {
                historyNodeId,
                noteId,
            },
        });

        setDeleteModal({ open: false });
        refreshShortlistDetails();
    };

    const handleSaveEditNote = async () => {
        const { folderId, historyNodeId, noteId, note } = editModal;

        if (!note.trim()) return;

        await ClientService.editNote({
            candidateId,
            folderId,
            noteRequest: {
                historyNodeId,
                noteId,
                note,
            },
        });

        setEditModal({ open: false });
        refreshShortlistDetails();
    };



    if (!Array.isArray(shortlistDetails) || shortlistDetails.length === 0) {
        return null;
    }

    const activeFolder = shortlistDetails.find(
        (detail) => detail.folder?.folderId === activeTab
    );

    const historyNodes =
        activeFolder?.shortlistHistory?.shortlistHistoryNodes || [];

    const activeHistory = historyNodes[0];      
    const previousHistory = historyNodes.slice(1);


    return (
        <div className="sl-details-container">
            <div className="sl-folder-tabs-wrapper">
                <div className="sl-folder-tabs">
                    {shortlistDetails.map((detail) => {
                        const isActive = activeTab === detail.folder?.folderId;

                        return (
                            <div
                                key={detail.folder?.folderId}
                                className={`sl-folder-tab ${isActive ? 'active' : ''}`}
                                onClick={() => setActiveTab(detail.folder?.folderId)}
                            >
                                {detail.folder?.name}
                            </div>
                        );
                    })}
                </div>

                {shortlistDetails.length > 5 && (
                    <div className="sl-folder-scroll-hint">
                        <span className="sl-folder-scroll-arrow">›</span>
                    </div>
                )}
            </div>
            {activeFolder && (
                <div
                    key={activeFolder.folder.folderId}
                    className="sl-details-folder">

                    {/* CURRENT STATUS */}
                    {activeHistory && (
                        <div className="sl-current-box">
                            <div className="sl-current-header">
                                <div className="sl-current-title">Current Status</div>
                                <button
                                    className="sl-btn-orange sl-add-note-top"
                                    onClick={() => setAddNoteModal({ open: true, note: '' })}
                                >
                                    Add Note
                                </button>
                            </div>
                            <ShortlistHistoryItem
                                history={{
                                    historyNodeId: activeHistory.id,
                                    shortlistStatus: activeHistory.shortlistStatus,
                                    createdAt: activeHistory.createdAt,
                                    createdByName: activeHistory.createdByName,
                                    notes: activeHistory.notes || [],
                                }}
                                folderId={activeFolder.folder?.folderId}
                                candidateId={candidateId}
                                username={username}
                                refreshShortlistDetails={refreshShortlistDetails}
                                onAddNote={handleAddNote}
                                onEditNote={handleEditNote}
                                onDeleteNote={handleDeleteNote}
                                isLast
                            />
                        </div>
                    )}

                    {/* HISTORY */}
                    <div className="sl-history">
                        {/* {historyNodes.slice(0, -1).map((history) => ( */}
                        {previousHistory.map((history) => (
                            <ShortlistHistoryItem
                                key={`${activeFolder.folder?.folderId}-${history.id}`}
                                history={{
                                    historyNodeId: history.id,
                                    shortlistStatus: history.shortlistStatus,
                                    createdAt: history.createdAt,
                                    createdByName: history.createdByName,
                                    notes: history.notes || [],
                                }}
                                isLast={false}
                                folderId={activeFolder.folder?.folderId}
                                username={username}
                                onEditNote={handleEditNote}
                                onDeleteNote={handleDeleteNote}

                            />
                        ))}
                    </div>

                </div>

            )}

            <>
                <Modal
                    show={editModal.open}
                    onHide={() => setEditModal({ open: false })}
                    centered
                    className="sl-edit-note-modal"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Note</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <textarea
                            className="sl-edit-note-textarea"
                            value={editModal.note}
                            onChange={(e) =>
                                setEditModal({ ...editModal, note: e.target.value })
                            }
                        />
                    </Modal.Body>

                    <Modal.Footer className="sl-modal-footer-center">
                        <Button
                            className="sl-btn-cancel"
                            onClick={() => setEditModal({ open: false })}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="sl-btn-save"
                            onClick={handleSaveEditNote}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Modal
                    show={addNoteModal.open}
                    onHide={() => setAddNoteModal({ open: false, note: '' })}
                    centered
                    className='sl-edit-note-modal'
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Add Note</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <textarea
                            className="sl-edit-note-textarea"
                            placeholder="Add note"
                            value={addNoteModal.note}
                            onChange={(e) =>
                                setAddNoteModal({ ...addNoteModal, note: e.target.value })
                            }
                        />
                    </Modal.Body>

                    <Modal.Footer className="sl-modal-footer-center">
                        <Button
                            className="sl-btn-cancel"
                            onClick={() => setAddNoteModal({ open: false, note: '' })}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="sl-btn-save"
                            onClick={async () => {
                                await handleAddNote(
                                    activeFolder.folder.folderId,
                                    activeHistory.id,
                                    addNoteModal.note
                                );
                                setAddNoteModal({ open: false, note: '' });
                            }}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={deleteModal.open}
                    onHide={() => setDeleteModal({ open: false })}
                    centered
                    className="sl-edit-note-modal"
                >

                    <Modal.Header closeButton>
                        <Modal.Title>Delete Note</Modal.Title>
                    </Modal.Header>

                    <Modal.Body >
                        Are you sure you want to delete this note?
                    </Modal.Body>

                    <Modal.Footer className="sl-modal-footer-center">
                        <Button
                            className="sl-btn-cancel"
                            onClick={() => setDeleteModal({ open: false })}
                        >
                            Cancel
                        </Button>
                        <Button
                            className="sl-btn-save"
                            onClick={confirmDeleteNote}
                        >
                            Yes
                        </Button>

                    </Modal.Footer>
                </Modal>

            </>
        </div>


    );
};